/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 radar.glb -T -K -R 1024 -k -M 
Files: radar.glb [24.04KB] > /Users/Mancini/Documents/Dopple/Scout670/radar-transformed.glb [23KB] (4%)
*/

import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from "@react-three/drei";

export function Radar(props) {
  const { nodes, materials } = useGLTF("/radar-transformed.glb");
  const radarRef = useRef();

  useFrame(() => {
    radarRef.current.rotation.y += 0.01;
  });

  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="radar"
          castShadow
          ref={radarRef}
          geometry={nodes.radar.geometry}
          material={materials.white_plastic}
          position={[-317.273, 94.851, 0.062]}
          rotation={[0, 0, 0.001]}
          scale={0.025}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/radar-transformed.glb");
